import { Box, SxProps, Theme, useTheme } from "@mui/material";

export type ContentWrapperProps = {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

export const ContentWrapper = ({ children, sx }: ContentWrapperProps) => {
    const theme = useTheme();

    const styles = {
        ...(sx || {}),
        width: "100%",
        height: `calc(100vh - ${theme.variables.appBarHeight}px)`,
        overflow: "auto",
    }

    return (
        <Box sx={styles}>
            {children}
        </Box>
    );
}